// Re-encodes an image blob as JPEG, scaling it down so its longest edge does
// not exceed maxEdge. Canvas re-encoding is near-instant, unlike re-running a
// WASM HEIC decode, so this is the cheap way to shrink an oversized conversion.
export const downscaleImageBlobToJpeg = async (
    blob: Blob,
    maxEdge: number,
    quality: number
): Promise<Blob> => {
    const bitmap = await createImageBitmap(blob);
    try {
        const scale = Math.min(
            1,
            maxEdge / Math.max(bitmap.width, bitmap.height)
        );
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(bitmap.width * scale);
        canvas.height = Math.round(bitmap.height * scale);
        canvas
            .getContext('2d')
            .drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        return await new Promise<Blob>((resolve, reject) => {
            canvas.toBlob(
                (result) =>
                    result
                        ? resolve(result)
                        : reject(new Error('Canvas encoding failed')),
                'image/jpeg',
                quality
            );
        });
    } finally {
        bitmap.close();
    }
};
